RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.DualGraph = Marionette.CompositeView.extend({
        ui: {
            header: '.x-dual-graph-header',
            bars: '.x-dual-graph-bars',
            legend: '.x-dual-graph-legend',
            footer: '.x-dual-graph-footer',
            legendItem: '.x-dual-graph-legend-item'
        },
        events: {
            'click @ui.legendItem': 'onLegendItemClicked',
            'click @ui.bars': 'onBarsClicked',
            'click': 'onMeClicked'
        },
        borderPixelWidth: 2,
        className: 'row x-dual-graph',
        mixedClassName: 'x-mixed',
        template: '#dualGraphTemplate',
        childView: views.DualGraphBar,
        childViewContainer: '.x-dual-graph-bars',
        initialize: function () {
            const me = this;

            _.bindAll(me, 'onWindowResize');

            me.collection = new Backbone.Collection(me.model.get('bars'));

            $(window).on('resize', me.onWindowResize);
        },
        childViewOptions: function (model, index) {
            const me = this;

            return {
                // we need to determine the max of all totals so that the bar
                // can determine its percentage (bar.primaryLabel / max);
                // which is used as the width
                max: me.getMax(),
                // we need to determine the min of all totals so that we
                // can align the axis tick in the event of a negative value
                // (e.g., -0.05)
                min: me.getMin(),
                color: me.getOption('color'),
                barIndex: index
            };
        },
        onShow: function () {
            const me = this;
            me.onWindowResize();
        },
        onRender: function () {
            const me = this;
            const model = me.model;

            const header = model.get('header');

            // if we have a header then render it
            if (header) {
                const hasLink = Boolean(header.link);
                // add a boolean that we can count on in the header view
                // for determining whether or not to render the link anchor
                const attributes = _.extend({
                    hasLink: hasLink
                }, header);

                me.header = new views.DualGraphHeader({
                    el: me.ui.header,
                    model: new Backbone.Model(attributes)
                }).render();
            }

            const legend = model.get('legend');

            // determine if we have a legend to render, and render it if we do
            if (legend && legend.length) {
                new views.DualGraphLegend({
                    el: me.ui.legend,
                    collection: new Backbone.Collection(legend)
                }).render();
            }

            const footer = model.get('footer');

            // if we have a footer then render it
            if (footer) {
                me.footer = new views.DualGraphFooter({
                    el: me.ui.footer,
                    model: new Backbone.Model(footer)
                }).render();
            }

            // we have mixed (negative and positive) values
            if (me.getMax() >= 0 && me.getMin() < 0) {
                me.$el.addClass(me.mixedClassName);
            }
        },

        serializeData: function () {
            const me = this;

            return {
                legendClass: me.model.get('legendClass') || ''
            };
        },

        getMax: function () {
            return this.collection.reduce(function (memo, model) {
                const primaryLabel = model.get('primaryLabel');
                return primaryLabel > memo ? primaryLabel : memo;
            }, -Number.MAX_VALUE);
        },
        getMin: function () {
            return this.collection.reduce(function (memo, model) {
                const primaryLabel = model.get('primaryLabel');
                return primaryLabel < memo ? primaryLabel : memo;
            }, Number.MAX_VALUE);
        },
        onWindowResize: function () {
            const me = this;

            if (me.width !== me.$el.width()) {
                me.onObserveMutation();
            }
        },
        onObserveMutation: function () {
            let callback;
            const me = this;
            const min = me.getMin();
            const max = me.getMax();

            if (max < 0 || (min < 0 && max >= 0)) {
                // all negative, and mixed cases
                callback = function (el, maxWidth) {
                    const bumper = $(el).prev();
                    me.adjustElementWidth(bumper[0], maxWidth);
                };
            }

            const maxBarLabel = me.getMaxBarLabel();

            if (!maxBarLabel) {
                return;
            }

            const container = maxBarLabel.parent();

            // there are extra pixels for the bar border
            const maxBarWidth = container.width() - maxBarLabel.width() - me.borderPixelWidth;

            me.adjustBarWidths(maxBarWidth, callback);

            me.width = me.$el.width();
        },
        onDestroy: function () {
            const me = this;
            $(window).off('resize', me.onWindowResize);
        },
        getMaxBarLabel: function () {
            const me = this;

            return _.reduce(me.$('.x-dual-graph-bar-labels'), function (memo, el) {
                const $el = $(el);

                if (memo) {
                    return memo.width() < $el.width() ? $el : memo;
                } else if ($el.width()) {
                    return $el;
                }
            }, void(0));
        },
        adjustBarWidths: function (maxWidth, callback) {
            const me = this;

            me.$('.x-dual-graph-bar-parts').each(function (i, el) {
                if (callback) {
                    callback(el, maxWidth);
                }

                me.adjustElementWidth(el, maxWidth);
            });
        },
        adjustElementWidth: function (el, maxWidth) {
            const $el = $(el);
            const percent = $el.attr('data-percent');

            if (!percent) {
                return;
            }

            const pixelWidth = maxWidth * percent;
            $el.width(pixelWidth);
        },
        onMeClicked: function () {
            const me = this;
            if (me.header) {
                me.header.showDetails();
            } else if (me.footer) {
                me.footer.showDetails();
            }

        },

        onLegendItemClicked: function (e) {
            const me = this;
            me.trigger('legend:clicked', $(e.currentTarget).data('id'));
        },

        onBarsClicked: function () {
            const me = this;
            me.trigger('bars:clicked');
        }
    });
});
